(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-list"] && !Shopify.designMode) return;
  try {
    (() => {
    const loadCardImages = () => {
      for (const img of document.querySelectorAll('img[data-loki-srcset]')) {
        img.srcset = img.dataset.lokiSrcset;
        img.src = img.dataset.lokiSrc;
        img.removeAttribute('data-loki-srcset');
      }
    };
    for (const menu of document.querySelectorAll('.menu-list')) {
      menu.addEventListener('pointerenter', loadCardImages, { once: true });
      menu.addEventListener('focusin', loadCardImages, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
